export default __webpack_public_path__ + "static/leaf-3b609ca8a4bcd42b61ef57bb08fd7038.png";